<template>
  <div>
    <div class="display-1 font-weight-light mb-5">
      <span class="pl-5">Zkušenosti</span>
      <v-divider></v-divider>
    </div>

    <v-container fluid class="pa-0 mb-5">
      <v-row>
        <v-col cols="12" class="pa-0">
          <v-row align="center" justify="center" v-for="(group, index) in skillGroups" :key="`group_${index}`">
            <v-card tile flat class="pt-5 pl-5 pr-5" v-for="(item, index) in group" :key="`item_${index}`">
              <a :href="item.href" target="_blank">
                <img :src="item.src" :alt="item.alt">
              </a>
            </v-card>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  export default {
    name: "Skills",
    data () {
      return {
        skillGroups: [
          [
            {
              href: 'https://www.php.net',
              src: '/img/logos/lang/php.png',
              alt: '',
            },
            {
              href: 'https://www.java.com/en',
              src: '/img/logos/lang/java.png',
              alt: '',
            },
            {
              href: 'https://www.python.org',
              src: '/img/logos/lang/python.png',
              alt: '',
            }
          ],
          [
            {
              href: 'https://framework.zend.com',
              src: '/img/logos/php/zend.png',
              alt: '',
            },
            {
              href: 'https://phalcon.io/en-us',
              src: '/img/logos/php/phalcon.png',
              alt: '',
            },
            {
              href: 'https://symfony.com',
              src: '/img/logos/php/symfony.png',
              alt: '',
            },
            {
              href: 'https://laravel.com',
              src: '/img/logos/php/laravel.png',
              alt: '',
            },
          ],
          [
            {
              href: 'https://jquery.com',
              src: '/img/logos/js/jquery.png',
              alt: ''
            },
            {
              href: 'https://vuejs.org',
              src: '/img/logos/js/vue.png',
              alt: ''
            },
            {
              href: 'https://backbonejs.org',
              src: '/img/logos/js/backbone.png',
              alt: ''
            },
          ],
          [
            {
              href: 'https://developer.mozilla.org/en-US/docs/Learn/Getting_started_with_the_web/JavaScript_basics',
              src: '/img/logos/web/javascript.png',
              alt: ''
            },
            {
              href: 'https://www.w3schools.com/html/html5_intro.asp',
              src: '/img/logos/web/html5.png',
              alt: ''
            },
            {
              href: 'https://developer.mozilla.org/en-US/docs/Web/CSS/Reference',
              src: '/img/logos/web/css3.png',
              alt: ''
            },
            {
              href: 'https://sass-lang.com',
              src: '/img/logos/web/sass.png',
              alt: ''
            },
            {
              href: 'http://lesscss.org',
              src: '/img/logos/web/less.png',
              alt: ''
            },
          ],
          [
            {
              href: 'https://www.mysql.com',
              src: '/img/logos/db/mysql.png',
              alt: ''
            },
            {
              href: 'https://mariadb.org',
              src: '/img/logos/db/mariadb.png',
              alt: ''
            },
            {
              href: 'https://www.postgresql.org',
              src: '/img/logos/db/postgresql.png',
              alt: ''
            },
            {
              href: 'https://www.sap.com/products/sql-anywhere.html',
              src: '/img/logos/db/sqlanywhere.png',
              alt: ''
            },
          ],
        ],
      }
    }
  }
</script>

<style scoped>
  img {
    max-height: 84px;
    max-width: 220px;
  }
  .v-card {
    background-color: inherit;
  }
</style>